import React, { useEffect, useState,  } from 'react'
import { Container, Row, Col, Button, Modal, Form } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import useAuth from '../../../context/auth/useAuth'
import { Link } from 'react-router-dom'
import { addRestaurant, getRestaurants } from '../../../actions/restaurantsActions'
import { CustomDataTable } from '../../../components/design/Datatables/CustomDataTable'
import Swal from 'sweetalert2'

export default function Restaurants() { 
  	const { t } = useTranslation()
	const dispatch = useDispatch()
	const {client} = useAuth()

	const {restaurants, resultrestaurant} = useSelector(state=>state.restaurants)

    const [modalShow, setModalShow] = useState(false)
    const [newRestaurant, setNewRestaurant] = useState({ })
    const [imageAux, setImage] = useState(null)
    const [isRegistering, setIsRegistering] = useState(false)

	useEffect(() => {
		if(client){
			dispatch(getRestaurants())
		}
	},[dispatch, t, client])


    const openModal = () =>{
        setNewRestaurant({
            name: '',
            address: '',
            schedule: {
                monday: {scheduleopen: '00:00', scheduleclose: '00:00'},
                tuesday: {scheduleopen: '00:00', scheduleclose: '00:00'},
                wednesday: {scheduleopen: '00:00', scheduleclose: '00:00'},
                thursday: {scheduleopen: '00:00', scheduleclose: '00:00'},
                friday: {scheduleopen: '00:00', scheduleclose: '00:00'},
                saturday: {scheduleopen: '00:00', scheduleclose: '00:00'},
                sunday: {scheduleopen: '00:00', scheduleclose: '00:00'},
            },
            image: null
        })
        setModalShow(true)
    }

    const handleInputChange = ({target})=>{
        setNewRestaurant({
            ...newRestaurant,
            [target.name]: target.value
        })
    }
    const handleCheckboxChange = ({target}) => {
        setNewRestaurant({
            ...newRestaurant,
            [target.name]: target.checked
        })
    }

    const handleInputScheduleChange = async(day, e) => {
        e.preventDefault()

        setNewRestaurant({
            ...newRestaurant,
            schedule: {
                ...newRestaurant.schedule,
                [day]: {
                    ...newRestaurant.schedule[day],
                    [e.target.name]: e.target.value
                }
            }
        })
    }

    const handleImage = (e)=>{
		setImage(e.target.files[0])
    }

    const handleAdd = async(e) => {
        e.preventDefault()
        setIsRegistering(true)
        dispatch(addRestaurant(imageAux, newRestaurant))
        setIsRegistering(false)
    }

    useEffect(() => {
        if(resultrestaurant){
            switch (resultrestaurant) {
                case 'success':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.restaurants.addsuccess')
                    }).then(() => {
                        setModalShow(false)  
                        setImage(null)
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultrestaurant])

	const columnsRestaurants = [
		{
			name: t('admin.restaurants.name'),
			cell: restaurant =>
				<div>
					{restaurant.name}
				</div>,
			selector: (restaurant) => restaurant.name,
			sortable: true,
		},{
			name: t('admin.restaurants.address'),
			cell: restaurant =>
				<div>
					{restaurant.address}
				</div>,
			selector: (restaurant) => restaurant.address,
			sortable: true,
		},{
			name: t('admin.restaurants.schedule'),
			cell: restaurant =>
				<div>
                    {restaurant?.schedule?.monday?.scheduleopen !== '00:00' || restaurant?.schedule?.monday?.scheduleclose !== '00:00' ? t('admin.restaurants.monday')+': '+restaurant?.schedule?.monday?.scheduleopen+' - '+restaurant?.schedule?.monday?.scheduleclose+'\n': ''}
                    {restaurant?.schedule?.tuesday?.scheduleopen !== '00:00' || restaurant?.schedule?.tuesday?.scheduleclose !== '00:00' ? t('admin.restaurants.tuesday')+': '+restaurant?.schedule?.tuesday?.scheduleopen+' - '+restaurant?.schedule?.tuesday?.scheduleclose+'\n': ''}
                    {restaurant?.schedule?.wednesday?.scheduleopen !== '00:00' || restaurant?.schedule?.wednesday?.scheduleclose !== '00:00' ? t('admin.restaurants.wednesday')+': '+restaurant?.schedule?.wednesday?.scheduleopen+' - '+restaurant?.schedule?.wednesday?.scheduleclose+'\n': ''}
                    {restaurant?.schedule?.thursday?.scheduleopen !== '00:00' || restaurant?.schedule?.thursday?.scheduleclose !== '00:00' ? t('admin.restaurants.thursday')+': '+restaurant?.schedule?.thursday?.scheduleopen+' - '+restaurant?.schedule?.thursday?.scheduleclose+'\n': ''}
                    {restaurant?.schedule?.friday?.scheduleopen !== '00:00' || restaurant?.schedule?.friday?.scheduleclose !== '00:00' ? t('admin.restaurants.friday')+': '+restaurant?.schedule?.friday?.scheduleopen+' - '+restaurant?.schedule?.friday?.scheduleclose+'\n': ''}
                    {restaurant?.schedule?.saturday?.scheduleopen !== '00:00' || restaurant?.schedule?.saturday?.scheduleclose !== '00:00' ? t('admin.restaurants.saturday')+': '+restaurant?.schedule?.saturday?.scheduleopen+' - '+restaurant?.schedule?.saturday?.scheduleclose+'\n': ''}
                    {restaurant?.schedule?.sunday?.scheduleopen !== '00:00' || restaurant?.schedule?.sunday?.scheduleclose !== '00:00' ? t('admin.restaurants.sunday')+': '+restaurant?.schedule?.sunday?.scheduleopen+' - '+restaurant?.schedule?.sunday?.scheduleclose+'\n': ''}
				</div>,
			selector: (restaurant) => restaurant.schedule,
			sortable: true,
		},{
			name: t('admin.restaurants.active'),
			cell: restaurant =>
				<div>
                    {restaurant.active
						?
							<img src="../images/check.svg" alt="check" width={25}></img>
						:
                            <img src="../images/times.svg" alt="times" width={25}></img>
					}
				</div>,
			selector: (restaurant) => restaurant.active,
			sortable: true,
		},{
			name: '',
			cell: restaurant =>
				<div>
					<Link to={`/admin/restaurants/${restaurant._id}`}>
						{t('admin.restaurants.edit')}
					</Link>
				</div>,
			sortable: false,
		}
	]

	return (
        <Container className='p-5'>
            <Row className="mb-3">
                <Col xs={2} className='p-0'>
                    <Link className="p-0 my-3" to="/admin/dashboard">
                        <img src="../images/arrow-back.svg" alt="arrow-back" width={25}></img>
                    </Link>
                </Col>
                <Col xs={8} className='text-center'>
                    <h1 className='fs-18'>{t('admin.restaurants.restaurants')}</h1>
                </Col>
                <Col xs={2}></Col>
            </Row>
            <Row className="mt-5 mb-4">
                <Button variant='primary' type="submit" className="btn-primary my-2 button-withicon" onClick={() => openModal()}>
                    <label className='label-button'>{t('admin.restaurants.createrestaurant')}</label>
                </Button>
            </Row>
            <Row className="mt-5 ">
                <label className='sd-label-medium'>{t('admin.restaurants.listrestaurants')}</label>
            </Row>
            <Row>
                {restaurants?.length > 0
                    ?
                        <CustomDataTable columns={columnsRestaurants} data={restaurants} />
                    :
                        <h4 className='mt-4'>{t('admin.restaurants.thereisnotrestaurants')}</h4>
                }
            </Row>
            <Modal show={modalShow} className="sd-modal" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
                    <i className='fa fa-times' onClick={() => setModalShow(false)}></i>
                </Modal.Header>
                <Modal.Body>
                    <div className='text-center'>
                        <label className='sd-label-create'>{t('admin.restaurants.createrestaurant')}</label>
                    </div>
                    <Form className="px-4 formulario" onSubmit={handleAdd}>
                        <Row className="text-center my-3">
                            <h2 className="sd-label text-start fs-16 fw-400">{t('admin.restaurants.namerestaurant')}*</h2>
                            <Form.Control
                                className="sd-input"
                                type='text'
                                name='name'
                                value={newRestaurant.name ||  ''}
                                placeholder={t('admin.restaurants.setname')}
                                onChange={handleInputChange}
                                required
                            />
                        </Row>
                        <Row className="text-center my-3">
                            <h2 className="sd-label text-start fs-16 fw-400">{t('admin.restaurants.addressrestaurant')}*</h2>
                            <Form.Control
                                className="sd-input"
                                type='text'
                                name='address'
                                value={newRestaurant.address || ''}
                                placeholder={t('admin.restaurants.setaddress')}
                                onChange={handleInputChange}
                                required
                            />
                        </Row>
                        <Row className="text-center mt-3">
                            <h2 className="sd-label text-start">{t('admin.restaurants.drinksincluded')}</h2>
                        </Row>
                        <Row>
                            <Form.Check
                                className="ms-3"
                                type="switch"
                                name="drinkIncluded"
                                onChange={handleCheckboxChange}
                                checked={newRestaurant?.drinkIncluded || false}
                            />
                        </Row>
                        <Row className="text-center mt-3 align-items-center">
                            <h2 className="sd-label text-start fs-16 fw-400">{t('admin.restaurants.schedulerestaurant')}*</h2>
                        </Row>
                        {['monday', 'tuesday','wednesday', 'thursday', 'friday', 'saturday', 'sunday'].map((day, key) => (
                            <Row className="text-center mb-3 align-items-center" key={key}>
                                <Col xs={12} md={4}>{t('admin.restaurants.'+day)}</Col>
                                <Col className='p-0'>
                                    <Form.Control
                                        className="sd-input"
                                        type='time'
                                        name='scheduleopen'
                                        //eslint-disable-next-line
                                        value={eval(`newRestaurant?.schedule?.${day}?.scheduleopen`) || ''}
                                        onChange={(e) => handleInputScheduleChange(day, e)}
                                        required
                                    />
                                </Col>
                                <Col xs={1}>-</Col>
                                <Col className='p-0'>
                                    <Form.Control
                                        className="sd-input"
                                        type='time'
                                        name='scheduleclose'
                                        //eslint-disable-next-line
                                        value={eval(`newRestaurant?.schedule?.${day}?.scheduleclose`) || ''}
                                        onChange={(e) => handleInputScheduleChange(day, e)}
                                        required
                                    />
                                </Col>
                            </Row>
                        ))}
                        <Row className="text-center my-3">
                            <h2 className="sd-label text-start fs-16 fw-400">{t('admin.restaurants.setimage')}</h2>
                            <Form.Control
                                className="sd-input"
                                type='file'
                                name='image'
                                // value={newRestaurant.image || ''}
                                onChange={handleImage}
                            />
                            {imageAux
                                ?
                                    <img className="img-profile mt-4" alt="Preview" src={typeof imageAux === 'string' ? imageAux : URL.createObjectURL(imageAux)} />
                                :
                                    newRestaurant.photo
                                        ?
                                            <img className="img-profile mt-4" alt="Preview" src={typeof newRestaurant.photo === 'string' ? newRestaurant.photo : URL.createObjectURL(newRestaurant.photo)} />
                                        :
                                            <div className="img-profile mt-4"></div>
                            }
                        </Row>
                        <Row className="text-center my-3">
                            <Col>
                                <Button variant='primary' type="submit" className="btn-primary w-100 my-2">
                                {isRegistering
                                    ?
                                        <>
                                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                        </>
                                    :
                                        <>{t('admin.restaurants.register')}</>
                                }
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
            </Modal>
        </Container>
	)
}